// extracted by mini-css-extract-plugin
module.exports = {"statusContainer":"singleTile_statusContainer__WKsOG","statusLabelAlignCenter":"singleTile_statusLabelAlignCenter__2CDVm","circleIcon":"singleTile_circleIcon__3d2P3"};